import ProgressTestRubricView from './component';
import _routes from './routes';

export const routes = _routes;

export default ProgressTestRubricView;



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestRubricView/index.js